import { render, staticRenderFns } from "./stationDetail.vue?vue&type=template&id=6678d9ee&scoped=true"
import script from "./stationDetail.vue?vue&type=script&lang=js"
export * from "./stationDetail.vue?vue&type=script&lang=js"
import style0 from "./stationDetail.vue?vue&type=style&index=0&id=6678d9ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6678d9ee",
  null
  
)

export default component.exports